module.exports = __webpack_public_path__ + "static/media/automation-play-icon.b187a0ca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/automation-play-icon.svg
// module id = ./src/assets/images/automation-play-icon.svg
// module chunks = 0